import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as clipboard from '@attain-apps/fe/web/main/lib/clipboard'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as me from '../../../me'

import { Api } from './api.service'
import { ClipboardItem } from './clipboard-item'
import * as plugins from './plugins'
import type { TypeParams } from './types'

/**
 * Collection of {@link Entity} (based on
 * {@link ents.core.mosaic.Action})
 *
 * Used on developer's page to manage actions
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const meFeature = ngCore.inject(me.Feature)

    super({
      api: ngCore.inject(Api),
      /**
       * {@link ents.core.me.Context.ForZone} which all Mosaic dev entity
       * collections use as their context
       */
      context$: meFeature.contexts.selectors.zoneContext.asObservable,
      identify: action => action.id,
      name: ec.Name.Predefined.MosaicAction,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory(collection => ({
            rowConfig: ({ rowIdx, entity }) => ({
              iconsConfigs: [
                {
                  class: 'atn-icon atn-trash atn-red',
                  onClick: () => {
                    collection.plugins.editingPlugin.feature.actions.markForDeletion
                      .from(`Table.Row-${rowIdx}.Buttons.Trash.Clicked`)
                      .dispatch({ id: entity.id })
                  },
                },
              ],
              onClick: () => {
                collection.plugins.editingPlugin.feature.actions.edit
                  .from(`Table.Row-${rowIdx}.Clicked`)
                  .dispatch({ id: entity.id })
              },
            }),
          })),
          new plugins.testing.Factory(),
          new clipboard.Factory({
            clipboardService: ngCore.inject(clipboard.Service),
            pasteClassRef: ClipboardItem,
          }),
        ],
      },
    })
  }
}
